<template>
    <div id="placement">
        <v-card-subtitle class="font-weight-bold pb-0">
            <v-icon :color="subAppColor" left>mdi-home-edit</v-icon> Placement Preferences
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="item.clusterPlacement" readonly hide-details label="Cluster Placement"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="pb-0 px-0">Cluster Preferences
                </v-card-subtitle>
                <v-row v-if="item.clusterPlacement == 'Interested'" class="px-0">
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.clusterChoice01" readonly hide-details label="First Choice"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.clusterChoice02" readonly hide-details label="Second Choice"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.clusterChoice03" readonly hide-details label="Third Choice"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="pb-0 px-0">Lifestyle
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" md="6" class="pb-0">
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I expect to get up before 9AM on weekdays" multiple
                            value="I expect to get up before 9AM on weekdays">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I usually stay up past midnight" multiple value="I usually stay up past midnight">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="Any kind of noise distracts me while im studying" multiple
                            value="Any kind of noise distracts me while im studying">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I like to study with background noise" value="I like to study with background noise">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I want my room to be a gathering place for friends" multiple
                            value="I want my room to be a gathering place for friends">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I prefer not to have many visitors in my room" multiple
                            value="I prefer not to have many visitors in my room">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0">
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I plan to maintain a fitness program" multiple
                            value="I plan to maintain a fitness program">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I plan to tryout for a visitor sports team" multiple
                            value="I plan to tryout for a visitor sports team">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I have toured/visited the residences at King's Unversity College" multiple
                            value="I have toured/visited the residences at King's Unversity College">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I would like to be involved in the Residence Council or King's University College Student Council"
                            multiple
                            value="I would like to be involved in the Residence Council or King's University College Student Council">
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" readonly dense hide-details
                            label="I am a smoker (Please be advised that smoking is NOT permitted in any residence building)"
                            multiple value="I am a smoker">
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-card-subtitle class="pb-0 px-0">My room is
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-radio-group v-model="item.lifestyleMyRoomIs" readonly>
                            <v-radio v-for="(item, index) in lifestyleMyRoomIsItems" :key="index" :label="item.text"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.applicantInterests" auto-grow readonly hide-details outlined
                            label="My Personal Interests" placeholder="Not available">
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'applicant-placement-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            lifestyleMyRoomIsItems: [{
                    text: 'Very neat',
                    value: '1'
                },
                {
                    text: '2',
                    value: '2'
                },
                {
                    text: '3',
                    value: '3'
                },
                {
                    text: '4',
                    value: '4'
                },
                {
                    text: '5',
                    value: '5'
                },
                {
                    text: '6',
                    value: '6'
                },
                {
                    text: '7',
                    value: '7'
                },
                {
                    text: '8',
                    value: '8'
                },
                {
                    text: '9',
                    value: '9'
                },
                {
                    text: 'Very messy',
                    value: '10'
                }
            ],
        }
    },
    computed: {
        subAppColor() {
            return '#FFA800';
        }
    }
}
</script>

<style scoped>
.v-input--checkbox,
.v-input--radio-group {
    margin-top: 0;
}
</style>